<template>
    <div>
        <div class="row">
            <div class="column small-6">
                <PageTitle title="Contracten" :total="total" :loading="loading" />
            </div>
            <div class="column small-6 medium-4 text-right" v-if="!user.deurwaarder">
                <b-button type="is-dark" class="marginbottom10" tag="router-link" :to="{ name: 'ContractsRecord', params: {id: 'nieuw'} }">Nieuw</b-button>
                <b-field class="cancelledswitch">
                    <span class="label">Toon gestopte contracten</span><b-switch :disabled="loading" v-model="showFinalizedContracts" type="is-success"></b-switch>
                </b-field>
            </div>
        </div>

        <div class="row" v-if="filters && Object.keys(filters).length">
            <div class="column">
                <h5>Filters</h5>

                <b-field>
                    <b-tag v-if="filters.confirmstops && filters.confirmstops == 1"
                        type="is-primary"
                        close-type='is-danger'
                        attached
                        closable
                        aria-close-label="Filter verwijderen"
                        @close="removeFilter('confirmstops')"
                    >
                        Contracten waar actie vereist is
                    </b-tag>
                </b-field>
            </div>
        </div>

        <div class="row" v-if="user.deurwaarder">
            <div class="column">
                <b-notification type="is-warning" role="alert">
                    Voor jouw rol zijn alleen contracten met geëscaleerde facturen zichtbaar.
                </b-notification>
            </div>
        </div>

        <div class="row">
            <div class="column">
                <ContractsOverviewTable
                    ref="ContractsOverviewTable"
                    @passTotal="passTotal"
                    @passLoading="passLoading"
                />
            </div>
        </div>
    </div>
</template>

<script>
import ContractsOverviewTable from './ContractsOverviewTable'

export default {
    name: 'ContractsOverview',

    components: {
        ContractsOverviewTable
    },

    computed: {
        user() {
            return this.$store.state.user
        }
    },

    data() {
        return {
            confirmStops: false,
            total: null,
            loading: false,
            filters: {},
            showFinalizedContracts: this.$store.state.showFinalizedContracts,
        }
    },

    created() {
        if(_.has(this.$route.query, 'confirmstops') && this.$route.query.confirmstops == 1){
            this.filters.confirmstops = this.$route.query.confirmstops
        } else {
            if (this.filters.confirmstops) {
                delete this.filters.confirmstops
            }
        }

        this.$store.dispatch('fetchConfirmStops')
    },

    methods: {
        passTotal(total){
            this.total = total
        },

        passLoading(loading) {
            this.loading = loading
        },

        removeFilter(filter){
            delete this.filters[filter]
            this.$router.push({ query: this.filters })
            this.$refs['ContractsOverviewTable'].loadAsyncData(this.filters.confirmstops ? 'confirmstops=1' : null)
        },
    },

    mounted() {
        // Check if in this session a query is saved (last success) else use default sorting.
        this.$refs['ContractsOverviewTable'].getSearchParams().then(() => {
            this.$refs['ContractsOverviewTable'].loadAsyncData(this.filters.confirmstops ? 'confirmstops=1' : null)
        })
    },

    watch: {
        '$route.query.confirmstops' (newVal, oldVal) {
            if (newVal === '1' && !oldVal) {
                this.filters.confirmstops = 1
            } else {
                delete this.filters.confirmstops
            }

            this.$refs['ContractsOverviewTable'].loadAsyncData(this.filters.confirmstops ? 'confirmstops=1' : null)
            this.$store.dispatch('fetchConfirmStops')
        },

        showFinalizedContracts(val) {
            // Only update store - the watcher in ContractsOverviewTable will handle reloading
            this.$store.dispatch('setShowFinalizedContracts', val)
        }
    }
}
</script>
